import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { find, keys } from 'lodash'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'
import { areSameValue } from '../../core/utils'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { UPDATE_DISH_MUTATION } from '../graphql/mutations'
import { UPDATE_DISH } from '../redux/action-types'

const useUpdateDishMutation = dishId => {
  const dispatch = useDispatch()

  const { isLoading, error } =
    useSelector(store =>
      find(store.dishes.dishes?.data?.result, ({ id }) =>
        areSameValue(id, dishId),
      ),
    ) || {}

  const mutate = useCallback(
    async data => {
      const logData = {
        dishId,
        sessionId: nanoid(),
        changedFields: keys(data),
      }

      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_DISH
          .MENU_CURATOR_START_UPDATE_DISH,
        {
          eventCategory: ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_DISH,
          ...logData,
        },
      )

      await apolloService.mutate({
        mutation: UPDATE_DISH_MUTATION,
        variables: { id: dishId, data },
        dispatch,
        action: UPDATE_DISH,
      })

      return firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_DISH.MENU_CURATOR_END_UPDATE_DISH,
        {
          eventCategory: ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_DISH,
          ...logData,
        },
      )
    },
    [dishId, dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateDishMutation
